import { useEffect, useRef, useState } from "react";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { useSelector } from "react-redux";

const CustomToolbar = (props: any) => {
  const [emojiModalVisible, setEmojiModalVisible] = useState(false);
  const InitialSetupReducer = useSelector((state: any) => state.customQueue);
  let { editData } = InitialSetupReducer;

  const toggleEmojiPicker = () => {
    setEmojiModalVisible(!emojiModalVisible);
  };
  const close = () => {
    setEmojiModalVisible(false);
  };
  const selectMessage = (e: any) => {
    const em = e.native;
    console.log("emoji", em)
    props.editorEmoji(em)
  };

  const pickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node)
      ) {
        close(); // call your close function
      }
    };

    if (emojiModalVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [emojiModalVisible, close]);
  return (
    <div id={props.id} className="toolbaricon">
      <div className="leftside">
        {props.editorEmoji ? 
        <span style={{ position: "relative" }}>
          <span >
            <button className="ql-emoji" onClick={() => toggleEmojiPicker()}>
            </button>
          </span></span> : ''}
        {emojiModalVisible && (<>
          <div className="emojipicker emojipickerwhtflow"   ref={pickerRef}>
            <Picker style={{ height: "100%" }} data={data} onEmojiSelect={selectMessage} onLeave={close} />
          </div></>
        )}
        {editData?.channel !== 'Instagram' &&
          <span>
            <button className="ql-bold" />
          </span>
        }
        {editData?.channel !== 'Instagram' &&
          <span>
            <button className="ql-italic" />
          </span>
        }
        {editData?.channel !== 'Instagram' &&
          <span>
            <button className="ql-strike" />
          </span>
        }
        <span>
          <button className="ql-list" value="ordered" />
        </span>
        <span>
          <button className="ql-list ql-bullet" value="bullet" />
        </span>
        {(editData?.channel !== 'Whatsapp' && editData?.channel !== 'Facebook' && editData?.channel !== 'Instagram') && (
          <span>
            <button className="ql-link" />
          </span>
        )}
      </div>
    </div>
  );
};
export default CustomToolbar;
